module.exports = __webpack_public_path__ + "img/浙江大学.dc0460d7.png";